
import {APP_URL, IMG_URL, amount_format,discount} from 'components/config/Common'

import { motion as ms } from 'framer-motion';
import {Links} from 'routes/PathLink'
import { Link } from "react-router-dom";

const supportData = [
  {
    img:'support/Depression_new.jpg',
    title: 'Depression',
    desc:'Are you feeling stuck in your sadness, struggling to see a way forward? We\'re here to help.',
  },
  {
    img:'support/2151169322.jpg',
    title: 'Social Anxiety',
    desc:'Do social situations make you feel anxious and nervous? We\'re here to help you handle them with more confidence.',
  },
  
  {
    img:'support/Alcohol-Addiction.jpg',
    title: 'Alcohol Addiction',
    desc:'Is alcohol getting in the way of living your life to the fullest? The right support is available for you.',
  },
  {
    img:'support/Bi-polardisorder.jpg',
    title: 'Bipolar Disorder',
    desc:'Do you go through extreme highs and lows, feeling really happy one moment and deeply sad the next? We\'re here to provide the care you need.',
  },
  {
    img:'support/Generalised-Anxiety-Disorder.jpg',
    title: 'Generalised Anxiety Disorder (GAD)',
    desc:'Do you often feel anxious, restless, or uneasy? We\'re here to help you find better ways to cope.',
  },
  {
    img:'support/Obsessive-Compulsive-Disorder.jpg',
    title: 'Obsessive Compulsive Disorder (OCD)',
    desc:'Are unwanted thoughts causing anxiety and leading to unhelpful habits? There are ways to cope, and we can help.',
  },  
  
]




const HealthSupport = () => {

   return(
      <div className="px-10 py-16 ">
        <h2 className="mb-4 mt-0  text-4xl">What are you having a hard time with?</h2>
        <p>Health Logist is here to help you with all your mental health needs.</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pt-10">
          {
            supportData && supportData.map((item, key) => (
          <div className="p-4">
            <div className="imagebox bg-light rounded-2xl servicesboxshadow  justify-center items-center w-full p-4 h-full" >
            <div className="flex w-full gap-3 items-center justify-center ">
              <div className="">
                <img src={`${IMG_URL}${item.img}`} className="w-[30%] imagebox aspect-square object-cover rounded-full mt-[-50px] hover:scale-125 transform transition duration-500"  />
              </div>
            </div>
             <h2 className="mt-4">{item.title}</h2>
             <p className="py-3">{item.desc}</p>
          </div>
          </div>
          ))
          }
          
        </div>
        
    </div>
   )
}



export default HealthSupport;